import React, {useEffect, useState} from 'react'
import { ExpansionList, ExpansionPanel, usePanels } from 'react-md'
import { storage } from '../../../../../services'
import { LoaderInfo, Hint } from '../../../../../libs/react-mpk/components'
import { number } from '../../../../../libs/react-mpk/services'
import { inject, observer } from 'mobx-react'
import t from 'counterpart'
import HeaderSSP from './HeaderSSP'
import DetailSSP from './DetailSSP'

const generate = () => {
  HeaderSSP.generate()
  DetailSSP.generate()
}

const SSP = (props) => {
  const induk = storage.get(storage.keys.SPT_1770S_INDUK)
  const [ready, setReady] = useState(false)
  const [panels, onKeyDown] = usePanels({
    idPrefix: 'spt-1770S-SSP',
    count:2,
    defaultExpandedIndex: 0
  })

  const handleSave = (key, update) => {
    storage.update(key, update);
    updateHeader()
  }

  const updateHeader = () => {
    let header = storage.get(storage.keys.SPT_1770S_HEADER_SSP)
    let detailSSP = storage.get(storage.keys.SPT_1770S_DETAIL_SSP)

    if(detailSSP){
      header.jumlahItem = String(detailSSP.daftarSSP.length)
      header.jumlahSetor = number.sumFormatted(
        ...detailSSP.daftarSSP.map( d => (d.jumlahSSP))
      )
      if(Number(header.jumlahItem) > 0){
        induk.checkList.checkGb = true
      } else {
        induk.checkList.checkGb = true
      }
      storage.update(storage.keys.SPT_1770S_INDUK, induk)
    }

    storage.update(storage.keys.SPT_1770S_HEADER_SSP, header)
  }

  useEffect(() => {
    updateHeader()
    setReady(true)
  }, [])

  const [panel1Props, panel2Props] = panels;
  return (
    <div 
      className="mod-submission-spt-1770S-SSP mpk-margin-C"
      style={{
        width: '100%',
        maxWidth: 800
      }}
    >
      { ready ? (
        <div>
          {props.errorMessage && 
            <div className="mpk-paper mpk-padding-N padding-all">
              <Hint>{props.errorMessage}</Hint>
            </div>
          }
          <ExpansionList onKeyDown={onKeyDown}>
            {[...(induk.E.flagE16 === '1'
              ? [{
                label: t.translate('modules.submission.sptForm.1770S.DetailSSP.title'),
                render: (<DetailSSP onSave={handleSave} {...props}/>),
                panelProps: panel1Props
              }] 
              : []),
              ...[
              {
                label: t.translate('modules.submission.sptForm.1770S.HeaderSSP.title'),
                render: (<HeaderSSP {...props}/>),
                panelProps: induk.E.flagE16 === '1' ? panel2Props : panel1Props
              },
            ]].map((p, i) => (
              <ExpansionPanel 
                key={`spt-1770S-SSP-panel-${i}`}
                {...p.panelProps}
                header={<div className="mpk-font size-M weight-M">{p.label}</div>}
              >
                {p.render}
              </ExpansionPanel>
            ))}
          </ExpansionList>
        </div>
      ) : <LoaderInfo/> }  
    </div>
  )
}

SSP.generate = generate

export default inject('navigationStore', 'envStore', 'authStore')(observer(SSP))
